import { useQuery } from "@tanstack/react-query";
import axios from "const/axios";
import { API_URL } from "const/constants";

/**
 * A custom ("Others") entry has its own routes for the same operations. They accept
 * accounts:other-entry:manage, which is the whole point: someone who does not work the Accounts
 * module can still raise a custom charge and send its payment for verification. The generic
 * client-account-details routes require the broader accounts keys, so an admin 403s on them.
 */
const paymentsBase = (cadId, isOtherEntry) =>
  isOtherEntry
    ? `${API_URL}/accounts/other-entries/${cadId}/payments`
    : `${API_URL}/accounts/client-account-details/${cadId}/payment-transactions`;

export const useCadPaymentTransactions = (cadId, enabled = true, isOtherEntry = false) =>
  useQuery({
    queryKey: ["cad-payment-transactions", cadId],
    queryFn: () => axios.get(paymentsBase(cadId, isOtherEntry)).then((r) => r.data?.data ?? []),
    enabled: Boolean(enabled) && !!cadId,
    refetchOnWindowFocus: false,
  });

export const useCadPaymentSummary = (cadId, enabled = true, isOtherEntry = false) =>
  useQuery({
    queryKey: ["cad-payment-summary", cadId],
    queryFn: () =>
      axios.get(`${paymentsBase(cadId, isOtherEntry)}/summary`).then((r) => r.data?.data ?? {}),
    enabled: Boolean(enabled) && !!cadId,
    refetchOnWindowFocus: false,
  });

export const addCadPaymentTransaction = (cadId, payload, isOtherEntry = false) =>
  axios.post(paymentsBase(cadId, isOtherEntry), payload);

export const resubmitModulePayment = (paymentId, payload, { cadId, isOtherEntry } = {}) =>
  axios.post(
    isOtherEntry
      ? `${API_URL}/accounts/other-entries/${cadId}/payments/${paymentId}/resubmit`
      : `${API_URL}/module-payments/${paymentId}/resubmit`,
    payload ?? undefined
  );
